import React from "react";
import { Button } from "primereact/button";

import CSUtil from "../../util/CSUtil";
import CSConfigUtil from "../../util/CSConfigUtil";
import CSServiceUtil from "../../util/CSServiceUtil";
import CSRequestUtil from "../../util/CSRequestUtil";
import { cfGetConstantValue } from "../../util/CSConstantUtil";

import CSCOReportTable from "./CSCOReportTable";
import CSCOReportChart from "./CSCOReportChart";

class CSCODashboardReportTile3 extends React.Component {
    constructor(props) {
        super(props);

        this.mCSUtil        = CSUtil.cfGetInstance();
        this.mCSServiceUtil = CSServiceUtil.cfGetInstance();
        this.mUnmountFlag   = false;

        this.state = {
            mReport             : this.props.pReport,
            mReportCriteriaData : null,
            mReportColumns      : null,
            mReportChart        : null,
            mReportChartProps   : null,
            mDataCollection     : null,
            mIsDashboardReport  : (this.props.pIsDashboardReport) ? this.props.pIsDashboardReport : true
        };

        this.cfGetReportData      = this.cfGetReportData.bind(this);
        this.cfProcessReportTable = this.cfProcessReportTable.bind(this);
        this.cfProcessReportChart = this.cfProcessReportChart.bind(this);
        this.cfProcessSearch      = this.cfProcessSearch.bind(this);
        this.cfProcessResponse    = this.cfProcessResponse.bind(this);
        this.cfGetReport          = this.cfGetReport.bind(this);
    }

    componentDidMount() {
        if (this.state.mReport) {
            this.cfGetReportData(this.state.mReport);
        }
    }

    componentDidUpdate(lPrevProps) {
        if (lPrevProps.pReport !== this.props.pReport) {
            const lReport = this.props.pReport;

            this.setState(
                {
                    mReport             : lReport,
                    mReportCriteriaData : null,
                    mReportColumns      : null,
                    mReportChart        : null,
                    mReportChartProps   : null,
                    mDataCollection     : null
                },
                () => {
                    if (lReport) {
                        this.cfGetReportData(lReport);
                    }
                }
            );
        }
    }

    componentWillUnmount() {
        this.mUnmountFlag = true;
    }

    cfGetReportData(lReportData) {
        if (!lReportData || this.mUnmountFlag) {
            return;
        }

        const lCriteria = {};
        lCriteria.app_code_        = CSConfigUtil.mAppCode;
        lCriteria.report_name_     = lReportData.report_name_;
        lCriteria.selected_report_ = lReportData;

        let lRequestUtil = null;

        if (lReportData.type_ === "Table") {
            lRequestUtil = new CSRequestUtil(
                "GET",
                "REQ_GET_REPORT_DATA",
                "cs_report",
                "REQ_GET_REPORT_DATA"
            );

            lRequestUtil.cfSetRequestCriteria(lCriteria);
            lRequestUtil.cfProcessRequest(this.cfProcessReportTable);
        } else if (lReportData.type_ === "Chart") {
            lRequestUtil = new CSRequestUtil(
                "GET",
                "REQ_GET_CHART_DATA",
                "cs_report",
                "REQ_GET_CHART_DATA"
            );

            lRequestUtil.cfSetRequestCriteria(lCriteria);
            lRequestUtil.cfProcessRequest(this.cfProcessReportChart);
        }
    }

    cfProcessReportTable(lResponse, lRequestCriteria) {
        if (this.mUnmountFlag) return;

        let lSelectedReport = null;
        if (lRequestCriteria) {
            lSelectedReport = lRequestCriteria.selected_report_;
        }

        if (lResponse) {
            let lReportCriteriaData = null;
            let lReportColumns      = null;

            if (lResponse.hasOwnProperty("report_criteria_")) {
                lReportCriteriaData = lResponse.report_criteria_;
            }

            if (lResponse.hasOwnProperty("report_table_column_")) {
                lReportColumns = lResponse.report_table_column_;
            }

            this.setState(
                {
                    mReportCriteriaData : lReportCriteriaData,
                    mReport             : lSelectedReport,
                    mReportColumns      : lReportColumns
                },
                () => {
                    if (!lReportCriteriaData) {
                        this.cfProcessSearch(null, lSelectedReport);
                    }
                }
            );
        } else {
            this.setState({
                mReportCriteriaData : null,
                mReport             : lSelectedReport,
                mReportColumns      : null
            });
        }
    }

    cfProcessReportChart(lResponse, lRequestCriteria) {
        if (this.mUnmountFlag) return;

        let lSelectedReport = null;
        if (lRequestCriteria) {
            lSelectedReport = lRequestCriteria.selected_report_;
        }

        if (lResponse) {
            let lReportCriteriaData = null;
            let lReportChart        = null;
            let lReportChartProps   = null;

            if (lResponse.hasOwnProperty("report_criteria_")) {
                lReportCriteriaData = lResponse.report_criteria_;
            }

            if (lResponse.hasOwnProperty("report_chart_")) {
                lReportChart = lResponse.report_chart_;
            }

            if (lResponse.hasOwnProperty("report_chart_property_")) {
                lReportChartProps = lResponse.report_chart_property_;
            }

            this.setState(
                {
                    mReportCriteriaData : lReportCriteriaData,
                    mReport             : lSelectedReport,
                    mReportChart        : lReportChart,
                    mReportChartProps   : lReportChartProps
                },
                () => {
                    if (!lReportCriteriaData) {
                        this.cfProcessSearch(null, lSelectedReport);
                    }
                }
            );
        } else {
            this.setState({
                mReportCriteriaData : null,
                mReport             : lSelectedReport,
                mReportChart        : null,
                mReportChartProps   : null
            });
        }
    }

    cfProcessSearch(lCriteria, lSelectedReport) {
        if (!lSelectedReport || !lSelectedReport.service_code_ || this.mUnmountFlag) {
            return;
        }

        const lServiceCode   = lSelectedReport.service_code_;
        const lServiceObject = this.mCSServiceUtil.cfGetServiceObject(lServiceCode);

        if (lServiceObject !== null) {
            const lCriteriaObj = (lCriteria) ? lCriteria : {};
            const lRequestUtil = new CSRequestUtil(
                "GET",
                lServiceCode,
                lServiceObject.type_,
                null,
                lServiceObject
            );

            if (lServiceObject.hasOwnProperty("cs_service_properties_")) {
                const lServiceProperties = lServiceObject.cs_service_properties_;
                if (lServiceProperties) {
                    for (let lInd = 0; lInd < lServiceProperties.length; lInd++) {
                        const lProp = lServiceProperties[lInd];
                        lCriteriaObj[lProp.property_] = cfGetConstantValue(lProp.value_);
                    }
                }
            }

            lRequestUtil.cfSetRequestCriteria(lCriteriaObj);
            lRequestUtil.cfProcessRequest(this.cfProcessResponse);
        }
    }

    cfProcessResponse(lResponse) {
        if (this.mUnmountFlag) return;

        let lCollection = [];

        if (lResponse && lResponse.hasOwnProperty("collection_") && lResponse.collection_) {
            if (lResponse.collection_ instanceof Array) {
                lCollection = lResponse.collection_;
            } else {
                lCollection.push(lResponse.collection_);
            }
        }

        this.setState({ mDataCollection: lCollection });
    }

    cfGetReport() {
        const lReport      = this.state.mReport;
        const lIsDashboard = this.state.mIsDashboardReport;

        if (!lReport) {
            return null;
        }

        if (lReport.type_ === "Table") {
            if (!this.state.mReportColumns) {
                return null;
            }

            return (
                <CSCOReportTable
                    pReportData         = { lReport }
                    pColumns            = { this.state.mReportColumns }
                    pParent             = { this }
                    pIsDashboardReport  = { lIsDashboard }
                    pDataCollection     = { this.state.mDataCollection }
                    pScrollHeight       = { "260px" }
                />
            );
        } else if (lReport.type_ === "Chart") {
            return (
                <CSCOReportChart
                    pReportData             = { lReport }
                    pReportCriteria         = { this.state.mReportCriteriaData }
                    pReportChart            = { this.state.mReportChart }
                    pReportChartProperties  = { this.state.mReportChartProps }
                    pParent                 = { this }
                    pIsDashboardReport      = { lIsDashboard }
                    pDataCollection         = { this.state.mDataCollection }
                />
            );
        }

        return null;
    }

    render() {
        const lReport  = this.state.mReport;
        if (!lReport) return null;

        const lHeading = lReport.report_heading_ || lReport.report_name_;

        return (
            <div
                className="cs-dashboard-report-tile"
                style={{
                    borderRadius   : "6px",
                    border         : "1px solid #dde2eb",
                    padding        : "6px 8px",
                    background     : "#ffffff",
                    display        : "flex",
                    flexDirection  : "column",
                    height         : "auto",
                    boxShadow      : "0 1px 2px rgba(0,0,0,0.08)"
                }}
            >
                <div
                    style={{
                        display        : "flex",
                        alignItems     : "center",
                        justifyContent : "space-between",
                        marginBottom   : "4px"
                    }}
                >
                    <div
                        style={{
                            fontSize      : "0.9rem",
                            fontWeight    : 600,
                            overflow      : "hidden",
                            textOverflow  : "ellipsis",
                            whiteSpace    : "nowrap"
                        }}
                        title={lHeading}
                    >
                        {lHeading}
                    </div>

                    <Button
                        type="button"
                        icon="pi pi-arrow-up-right"
                        className="p-button-text p-button-rounded p-button-sm"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (this.props.pOnPopout) {
                                this.props.pOnPopout();
                            }
                        }}
                    />
                </div>

                <div style={{ overflow: "hidden" }}>
                    {this.cfGetReport()}
                </div>
            </div>
        );
    }
}

export default CSCODashboardReportTile3;